import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/sources/fleets/$id/general/")({
  staticData: {
    title: "common.general",
  },
});
